var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('royalty-incentiveSLD',{attrs:{"title":_vm.title},model:{value:(_vm.kind),callback:function ($$v) {_vm.kind=$$v},expression:"kind"}})}
var staticRenderFns = []

export { render, staticRenderFns }